"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERequestStatus = void 0;
let ERequestStatus = exports.ERequestStatus = /*#__PURE__*/function (ERequestStatus) {
  ERequestStatus["Initial"] = "initial";
  ERequestStatus["Loading"] = "loading";
  ERequestStatus["Succeed"] = "succeed";
  ERequestStatus["Failed"] = "failed";
  return ERequestStatus;
}({});